module.exports = __webpack_public_path__ + "static/media/logo-full.10da1098.png";